import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyATJqEUUKQHnHKCEfQDnLiigJ0lSoPH4U8",
  authDomain: "kidsology-556f1.firebaseapp.com",
  projectId: "kidsology-556f1",
  storageBucket: "kidsology-556f1.firebasestorage.app",
  messagingSenderId: "189210921310",
  appId: "1:189210921310:web:56ec797e744d637b7927cf",
  measurementId: "G-K5TW2CYDJB"
};

const app = initializeApp(firebaseConfig);

/* Analytics (gtag.js, 160 KB) is loaded after the page has painted and
   the browser is idle, not with the first bundle: in Lighthouse it was
   the second heaviest script on every page (2026-10-08). Events sent
   before it is ready wait for it (src/lib/analytics.js). */
let analyticsPromise = null;
export function getAnalyticsApi() {
  if (!analyticsPromise) {
    analyticsPromise = import("firebase/analytics").then((m) => ({
      analytics: m.getAnalytics(app),
      logEvent: m.logEvent,
    }));
  }
  return analyticsPromise;
}
if (typeof window !== "undefined") {
  const start = () => window.setTimeout(() => getAnalyticsApi().catch(() => {}), 2500);
  if (document.readyState === "complete") start();
  else window.addEventListener("load", start, { once: true });
}

/* Firestore is only needed when a visitor submits a form, so it is
   loaded on demand instead of shipping in the main bundle (it was the
   second largest thing in it). Callers await this inside their submit
   handler:

     const { db, collection, addDoc, serverTimestamp } = await getFirestoreApi();
     await addDoc(collection(db, "homeContactLeads"), { ... });

   The chunk is cached after the first call, so a second form on the
   same visit costs nothing extra. */
let firestorePromise = null;
export function getFirestoreApi() {
  if (!firestorePromise) {
    firestorePromise = import("firebase/firestore").then((fs) => ({
      db: fs.getFirestore(app),
      collection: fs.collection,
      addDoc: fs.addDoc,
      serverTimestamp: fs.serverTimestamp,
    }));
  }
  return firestorePromise;
}
